<template>
  <div
      v-touch="{
      left: () => swipe('left'),
      right: () => swipe('right'),
    }" style="overflow-y: scroll" class="process-map-container inherit-height">
    <map-top class="mb-3"></map-top>
    <map-container class="flex-grow-1">
    </map-container>
    <map-bottom class="mt-3"></map-bottom>
  </div>
</template>

<script>
import MapContainer from '@/modules/document/boggProcessMap/MapContainer';
import MapBottom from '@/modules/document/boggProcessMap/MapBottom.vue';
import MapTop from "@/modules/document/boggProcessMap/MapTop.vue";
export default {
  name: 'BoggProcessMap',
  components: { MapBottom, MapContainer, MapTop },
  methods: {
    swipe(direction) {
      switch (direction) {
        case 'left':
          this.$router.go(1);
          break;
        case 'right':
          this.$router.go(-1);
          break;
        default:
          break;
      }
    }
  },
};
</script>

<style scoped>
.process-map-container {
  display: flex;
  flex-direction: column;
}

</style>